'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageFilterBAndW = function ImageFilterBAndW(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16l-7-8v8H5l7-8V5h7v14z' })
  );
};
ImageFilterBAndW = (0, _pure2.default)(ImageFilterBAndW);
ImageFilterBAndW.displayName = 'ImageFilterBAndW';
ImageFilterBAndW.muiName = 'SvgIcon';

exports.default = ImageFilterBAndW;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/image/filter-b-and-w.js
// module id = 1549
// module chunks = 0